import Vue from "vue";

export const ReportState = {
  report: null,
  reports: [],
  totalReports: 0,
  sections: []
};

export const ReportGetters = {
  report: state => {
    return state.report;
  },
  reports: state => {
    return state.reports;
  },
  totalReports: state => {
    return state.totalReports;
  },
  sections: state => {
    return state.sections;
  }
};

export const ReportMutations = {
  setReport: (state, data) => {
    if (data) {
      const index = state.reports.findIndex(
        i => Number(i.id) === Number(data.id)
      );
      if (index > -1) {
        const arr = [...state.reports];
        arr[index] = data;
        Vue.set(state, "reports", arr);
      }
    }
    Vue.set(state, "report", data);

    const arr = data.sections || state.sections;
    Vue.set(state, "sections", arr);
  },
  setReports: (state, data) => {
    Vue.set(state, "reports", data.reports);
    Vue.set(state, "totalReports", data.total_reports);
  },
  addReport: (state, data) => {
    Vue.set(state, "reports", [data, ...state.reports]);
    Vue.set(state, "totalReports", state.totalReports + 1);
  },
  removeReport: (state, data) => {
    const arr = state.reports.filter(i => i.slug !== data.slug);
    Vue.set(state, "reports", arr);
    Vue.set(state, "totalReports", state.totalReports - 1);
  },
  //
  setSection: (state, data) => {
    if (data) {
      const index = state.sections.findIndex(
        i => Number(i.id) === Number(data.id)
      );
      if (index > -1) {
        const arr = [...state.sections];
        arr[index] = data;
        Vue.set(state, "sections", arr);
      }
    }
  },
  setSections: (state, data) => {
    Vue.set(state, "sections", data);
  },
  addSection: (state, data) => {
    Vue.set(state, "sections", [...state.sections, data]);
  },
  removeSection: (state, data) => {
    const arr = state.sections.filter(i => Number(i.id) !== Number(data.id));
    Vue.set(state, "sections", arr);
  }
};

export const ReportActions = {
  getReport: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .get(`/api/v1/reports/${data.slug}`)
      .then(response => {
        commit("setReport", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch report from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  getReports: ({ commit, dispatch }, data = {}) => {
    const params = data.params || "";
    return Vue.axios.secured
      .get(`/api/v1/clients/${data.client_id}/reports${params}`)
      .then(response => {
        commit("setReports", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch reports from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  createReport: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .post(`/api/v1/clients/${data.client_id}/reports`, data.body)
      .then(response => {
        commit("addReport", response.data);
        const message = "Successfully created report.";
        dispatch("showToast", { message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to create report.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  publishReport: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/reports/${data.slug}`, { report: data.report })
      .then(response => {
        commit("setReport", response.data);
        const message = `Report ${response.data.name} has been successfully published.`;
        dispatch("showToast", { message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to publish report.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  updateReport: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/reports/${data.slug}`, { report: data.report })
      .then(response => {
        commit("setReport", response.data);
        const message = `Report ${response.data.name} has been successfully updated.`;
        dispatch("showToast", { message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update report.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  deleteReport: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .delete(`/api/v1/reports/${data.slug}`)
      .then(response => {
        commit("removeReport", data);
        const message = `Report ${data.report_name} has been successfully deleted.`;
        dispatch("showToast", { message, type: "success" });
        return { success: true };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to delete report.";
        dispatch("showToast", { message, type: "error" });
        return { success: false };
      });
  },
  deleteReports: ({ state, dispatch }, data = {}) => {
    return Vue.axios.secured
      .delete(`/api/v1/reports/bulk_delete?report_ids=${data.ids.toString()}`)
      .then(response => {
        state.reports = state.reports.filter(
          report => !data.ids.includes(report.id)
        );
        state.totalReports -= data.length;
        const message = `Reports has been successfully deleted.`;
        dispatch("showToast", { message, type: "success" });
        return { success: true };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to delete report.";
        dispatch("showToast", { message, type: "error" });
        return { success: false };
      });
  },
  downloadReports: ({ dispatch }, data = {}) => {
    return Vue.axios.secured
      .get(`/api/v1/reports/download?report_ids=${data.ids.toString()}`, {
        responseType: "blob"
      })
      .catch(error => {
        console.error(error);
        // const err = error.response && error.response.data;
        // const message = err || "Unable to download report.";
        // dispatch("showToast", { message, type: "error" });
      });
  },
  //
  getGraphDataSection: ({ dispatch }, data = {}) => {
    const params = data.params || "";
    const uri =
      data.type === "cumulative"
        ? `/api/v1/clients/${data.id}/cumulative${params}`
        : `/api/v1/targets/${data.id}/graph${params}`;
    return Vue.axios.secured
      .get(uri)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error(error);
        return null;
      });
  },
  getSections: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .get(`/api/v1/reports/${data.slug}/sections`)
      .then(response => {
        commit("setSections", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch sections from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  createSection: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .post(`/api/v1/reports/${data.slug}/sections`, { section: data.section })
      .then(response => {
        commit("addSection", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to create section.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  updateSection: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/sections/${data.id}`, { section: data.section })
      .then(response => {
        commit("setSection", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update report.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  deleteSection: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .delete(`/api/v1/sections/${data.id}`)
      .then(response => {
        commit("removeSection", data);
        // const message = `Section has been successfully removed.`;
        // dispatch("showToast", { message, type: "success" });
        return { success: true };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to delete section.";
        dispatch("showToast", { message, type: "error" });
        return { success: false };
      });
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/report.store.js